module.exports = __webpack_public_path__ + "assets/img/icon-dp.7950153d.png";